import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import PaisForm from '../PaisForm';

function PaisEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <PaisForm redirect="list" mode="edit">
        <DisabledInput label="Id" source="id" />
      </PaisForm>
    </Edit>
  );
}

export default PaisEdit;
